import api from 'api';

export const getFedexAccounts = (params) => {
  return api.get('/fedex_accounts', params, 'bearer');
};

export const getUserFedexAccounts = (params) => {
  return api.get('/user_fedex_accounts', params, 'bearer');
};

export const createUserFedexAccount = (body) => {
  return api.post('/user_fedex_accounts', body, 'bearer');
};

export const deleteUserFedexAccount = (id) => {
  return api.delete(`/user_fedex_accounts/${encodeURIComponent(id)}`, 'bearer');
};
